import type { PlaceRef } from '@viaja/contracts';
import { type AirportRef, placeDetail, searchPlaces } from '@viaja/domain';
import { useMemo, useState } from 'react';
import { Sheet } from '../../ui/Sheet';
import { TextField } from '../../ui/TextField';

export function toPlaceRef(a: AirportRef): PlaceRef {
  return { code: a.code, city: a.city, detail: placeDetail(a) };
}

/** Seletor de aeroporto/cidade, busca local sem acento (dados em @viaja/domain/airports). */
export function PlaceSheet({
  open,
  title,
  selected,
  onPick,
  onClose,
}: {
  open: boolean;
  title: string;
  selected?: string | undefined;
  onPick: (place: PlaceRef) => void;
  onClose: () => void;
}) {
  const [query, setQuery] = useState('');
  const results = useMemo(() => searchPlaces(query, 12), [query]);

  return (
    <Sheet
      open={open}
      title={title}
      onClose={() => {
        setQuery('');
        onClose();
      }}
    >
      <TextField
        label="Cidade ou aeroporto"
        type="search"
        placeholder="Ex.: Lisboa, GRU, Nova York"
        autoComplete="off"
        enterKeyHint="search"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        data-autofocus
      />
      {results.length === 0 ? (
        <p className="body app-meta">
          Não achei esse lugar. Tente o nome da cidade ou o código do aeroporto.
        </p>
      ) : (
        <ul className="app-options" aria-label="Resultados">
          {results.map((a) => (
            <li key={a.code}>
              <button
                type="button"
                className="app-option"
                aria-selected={selected === a.code}
                onClick={() => {
                  onPick(toPlaceRef(a));
                  setQuery('');
                }}
              >
                <span className="app-option-text">
                  <span className="body-strong">{a.city}</span>
                  <span className="caption app-meta">
                    {a.airports ? placeDetail(a) : `${a.name} · ${a.country}`}
                  </span>
                </span>
                <span className="caption app-option-code">{a.code}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </Sheet>
  );
}
